import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { ddmmyyyy } from "@/lib/format";
import { CashoutStatement } from "@/components/CashoutStatement";

export default function PublicCashoutsPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/cashouts/${token}`).then((r) => setData(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);

  if (err) return <p className="p-10 text-sm text-red-700" data-testid="cashout-share-error">{err}</p>;
  if (!data) return <p className="p-10 text-sm text-slate-500" data-testid="cashout-share-loading">Loading report…</p>;

  return (
    <div className="min-h-screen bg-slate-200 print:bg-white">
      <div className="no-print bg-slate-900 text-white">
        <div className="max-w-[1100px] mx-auto px-4 h-12 flex items-center gap-3 text-xs">
          <span className="text-white/70" data-testid="cashout-share-expiry">Shared report · link valid until {ddmmyyyy(data.expires_at.slice(0, 10))}</span>
          <button data-testid="cashout-share-print-btn" onClick={() => window.print()}
            className="ml-auto h-8 px-3 bg-yellow-300 text-slate-900 font-bold flex items-center gap-1.5 hover:bg-yellow-200">
            <Printer size={14} /> Print
          </button>
        </div>
      </div>
      <div className="max-w-[1100px] mx-auto my-6 print:my-0 bg-white p-5 sm:p-10 print:p-0 shadow-sm overflow-x-auto" data-testid="cashout-print-page">
        <CashoutStatement data={data} />
      </div>
    </div>
  );
}
